import { render, staticRenderFns } from "./AddAllowanceType.vue?vue&type=template&id=5b667ffe&scoped=true"
import script from "./AddAllowanceType.vue?vue&type=script&lang=js"
export * from "./AddAllowanceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b667ffe",
  null
  
)

export default component.exports